export default __webpack_public_path__ + "static/media/movie-world-img.f06932ee.png";